import { BaseConnector } from './baseConnector';

class UserConnector extends BaseConnector {
  getUsers() {
    var url = `${this.baseApiUrl}/user`;
    return this.authFetch(url);
  }
}

export { UserConnector };
